import { CATALYT_BASE_URL } from "./api";

export interface ICat2Config {
  baseURL: string;
  SID: string;
  appID: string;
  secretKey: string;
}

export const cat2Config = {
  baseURL: `${CATALYT_BASE_URL}/catalitv2`,
  secretKey:
    "iOpDvZqDCZ53doSkajYjMes11OabXliP3BhT8nBoK9ab2zVAPqSpq4BgAgMdvib4RyWRcS",
  appID: "115",
} as ICat2Config;
